'use client';

import Script from 'next/script';
import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';

export function LiveChatClient({
  livechatId,
  delayLoad = 0,
}: {
  livechatId: number;
  delayLoad?: number;
}): ReactNode {
  const [isLoaded, setIsLoaded] = useState(false);

  /**
   * We're delaying the loading of the LiveChat script because
   * even with the `lazyOnload` strategy it still is a blocking script.
   */
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setIsLoaded(true);
    }, delayLoad);

    return () => clearTimeout(timeoutId);
  }, [delayLoad]);

  if (!isLoaded) return null;

  return (
    <>
      <Script id="livechat-li" strategy="lazyOnload" async>
        {`
          window.__lc = window.__lc || {};
          window.__lc.license = ${livechatId};
        `}
      </Script>
      <Script id="livechat" src="https://cdn.livechatinc.com/tracking.js" strategy="lazyOnload" async />
    </>
  );
}
